import { SearchResponse } from './search-models';
import { ApiResponse } from './for-api';

export enum JobStatus {
  SUBMITTED = 'SUBMITTED',
  IN_PROGRESS = 'INPROGRESS',
  PAUSED = 'PAUSED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  DRAFTED = 'DRAFTED',
  NOT_FOUND = 'NOTFOUND',
  VALIDATING = 'VALIDATING',
  UNKNOWN = 'UNKNOWN',
}

export enum JobProgressStatus {
  PROGRESS = 'PROGRESS',
}

export type TemplateMetaData = {
  templateId: string;
  numberOfRecords: number;
  clientFileName: string;
};

export type NewJob = {
  programName: string;
  programId: string;
  userId: string;
  system: string;
  submittedDate: Date;
  completedDate?: Date;
  subCode?: string;
  status?: JobStatus;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  externalSystemRef: any;
  clientId?: string;
  externalMessage?: string;
  projectNumber?: string;
  isDeleted?: boolean;
  deletedBy?: string;
  deletedDate?: Date;
  tmsNumber: string;
  actions?: Array<string>;
  programMetaId?: string;
  isAps?: boolean;
  templateMetaData?: TemplateMetaData;
};

export interface Job extends NewJob {
  id: string;
}

export interface UpdateJobResponse {
  programId: string;
  action: string;
  message: string;
  status: string;
}

export interface SummaryData {
  submitted?: number;
  inProgress?: number;
  completed?: number;
  failed?: number;
  cancelled?: number;
}
export interface JobsStats {
  summaryData: SummaryData;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  jobsSearchData?: Record<string, any>;
}

export interface GraphInputProp {
  name: string;
  submitted?: number;
  inProgress?: number;
  completed?: number;
  failed?: number;
  cancelled?: number;
}
export interface GraphProps {
  [key: string]: GraphInputProp;
}

export class JobStatsConfig {
  public constructor(
    public completedCount: number,
    public cancelledCount: number,
    public failedCount: number,
    public apsJobs: number,
    public totalJobs: number,
    public normalJobs: number,
  ) {}
}
export type JobStatsCount = {
  jobStats?: JobStatsConfig[];
};

export type JobsSearchResponse = SearchResponse<Job> & JobStatsCount;
export type JobsApiSearchResponse = ApiResponse<JobsSearchResponse>;
export type JobsDeleteResponse = ApiResponse<unknown>;
export type JobsUpdateResponse = ApiResponse<UpdateJobResponse>;
export type JobsStatsResponse = ApiResponse<JobsStats>;
